// every permission the server understands, defined once; roles are sets of these
export const PERMISSIONS = {
  'content.read': 'See cities, zones, places, activities and fares',
  'content.write': 'Create and edit draft content',
  'content.publish': 'Publish content changes to players',
  'ads.read': 'See billboard inventory and creatives',
  'ads.write': 'Manage inventory, review creatives and schedule them',
  'players.read': 'Look up players',
  'players.support': 'Support actions on a player account',
  'players.ban': 'Suspend or ban players',
  'economy.read': 'See balances and economy reports',
  'economy.write': 'Adjust prices, rewards and balances',
  'moderation.chat': 'Moderate chat and reports',
  'settings.read': 'See game settings and feature flags',
  'settings.write': 'Change game settings and feature flags',
  'admins.manage': 'Create admins, assign roles and edit roles (super admin only)',
  'company.manage': 'Edit the company and legal details shown to players (super admin only)',
  'world.manage': 'Edit real-world facts shown in the game, such as the Prime Minister (super admin only)',
  'stats.manage': 'See the real visitor numbers and choose what the homepage shows (super admin only)',
  'audit.read': 'Read the audit log',
} as const;
export type PermissionKey = keyof typeof PERMISSIONS;
export const PERMISSION_KEYS = Object.keys(PERMISSIONS) as PermissionKey[];

// permissions only the super admin may ever hold or grant
export const SUPER_ADMIN_ONLY: PermissionKey[] = ['admins.manage', 'company.manage', 'world.manage', 'stats.manage'];

// permissions come from the union of an admin's roles
export function mergePermissions(roles: { permissions: string[] }[]): PermissionKey[] {
  const merged = new Set<string>();
  for (const role of roles) for (const permission of role.permissions) merged.add(permission);
  return PERMISSION_KEYS.filter((key) => merged.has(key));
}
export function hasPermission(granted: readonly string[], required: PermissionKey) {
  return granted.includes(required);
}
